<script lang="ts" setup>
import vuBtn from '@ds/vuekit/src/components/vu-btn.vue';

const emit = defineEmits(['click']);
const props = defineProps({
  color: {
    type: String,
    default: () => 'blue',
    required: false,
  },
  href: {
    type: String,
    default: () => '',
    required: false,
  },
  target: {
    type: String,
    default: () => '',
    required: false,
  },
});

const buttonClass = 'text--uppercase btn-lg px-20px';
</script>
<template>
  <template v-if="props.href">
    <a :href="props.href" :target="props.target">
      <vu-btn :class="[`${buttonClass} full-${props.color}-button`]">
        <slot name="default" />
      </vu-btn>
    </a>
  </template>
  <template v-else>
    <vu-btn :class="[`${buttonClass} full-${props.color}-button`]" @click.prevent="emit('click')">
      <slot name="default" />
    </vu-btn>
  </template>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.btn {
  line-height: 40px;
  min-width: 150px;
  position: relative;
  z-index: 1;
  overflow: hidden;

  @include variables.for-sm {
    line-height: 25px;
    width: 100%;
    max-width: 450px;
    font-size: 14px;
  }
}

.btn:hover::before {
  transform: translateY(100px);
}

.btn::before {
  display: block;
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  left: 0;
  top: -100px;
  z-index: -1;
  transition: transform 300ms ease;
}

.full-white-button {
  color: var(--blue-2);
  background-color: white !important;
}
.full-white-button::before {
  background-color: var(--grey-2) !important;
}

.full-blue-button {
  color: white;
  background-color: var(--blue-2) !important;
  border-color: var(--blue-2);
}
.full-blue-button::before {
  background-color: var(--blue-4) !important;
}

.full-blue-outline-button {
  border: 1px solid white;
  color: white;
  background-color: var(--blue-2) !important;
  transition: color 300ms ease;
}
.full-blue-outline-button:hover {
  color: var(--blue-2);
}
.full-blue-outline-button::before {
  background-color: white;
}
</style>
